module.exports = async function fetchAnonymousContent(
	url,
	method = "GET",
	body = null,
	headers = null,
	agent = null,
	returnResponse = false
) {
	const isFormData = body instanceof FormData;
	if (body && !isFormData && !(body instanceof File)) {
		body = JSON.stringify(body);
	}
	var init = {
		method: method,
		headers: {},
	};
	if (!isFormData) {
		init.headers["Content-Type"] = "application/vnd.api+json";
	}
	if (agent) {
		init.agent = agent;
	}
	Object.assign(init.headers, headers);
	if (body) {
		init.body = body;
	}

	if (returnResponse) {
		const fetchResponse = await fetch(url, init)
			.then((response) => {
				return response;
			})
			.catch(function (err) {
				console.error(err.message);
			});
		return fetchResponse;
	} else {
		try {
			return await fetch(url, init)
				.then(async (response) => {
					if (response.ok) {
						return response.json();
					} else {
						console.error(response.status + "  " + url);
						
						// Try to extract backend error message
						let backendErrorMessage = null;
						try {
							const errorText = await response.text();
							try {
								const errorJson = JSON.parse(errorText);
								if (errorJson.message) {
									backendErrorMessage = errorJson.message;
								} else if (errorJson.error) {
									backendErrorMessage = errorJson.error;
								}
							} catch (jsonError) {
								const messageMatch = errorText.match(/Message\s*([^\n\r]*)/i);
								if (messageMatch && messageMatch[1]) {
									backendErrorMessage = messageMatch[1].trim();
								}
							}
						} catch (textError) {
							console.error("Error parsing response text:", textError);
							backendErrorMessage = textError.message;
						}

						const errorMessage = backendErrorMessage
							? `${backendErrorMessage}`
							: `[01] Error: ${response.status} ${response.statusText} ${url}`;

						throw new Error(errorMessage);
					}
				})
				.then((response) => {
					if (response && !response.error) {
						return response;
					} else {
						let err_msg = response && response.error ? response.error : "Error";
						throw new Error("[02] " + err_msg);
					}
				})
				.catch(function (err) {
					console.error(err);
					throw new Error(err.message);
				});
		} catch (error) {
			console.error(error.message);
			return { error: error.message };
		}
	}
};
